export default {
  link: 'News',
  title: 'News',
  noDetailsTitle: 'No news',
  noDetailsText: 'Unfortunately, this content is not available in English',
};
